import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import { useLanguage } from '../../contexts/LanguageContext';

const BreadcrumbNavigation = () => {
  const location = useLocation();
  const { t, currentLanguage } = useLanguage();

  const routeLabels = {
    '/agency-dashboard': t('nav.dashboard'),
    '/super-admin-dashboard': t('nav.dashboard'),
    '/pilgrim-management': t('pilgrims.title'),
    '/pilgrim-profile': t('pilgrims.pilgrimDetails'),
    '/group-management': t('groups.title'),
    '/visa-management': t('visas.title'),
    '/financial-management': t('financial.title'),
    '/document-management': t('documents.title'),
    '/communication-center': t('communication.title'),
    '/agency-registration': t('registration.title')
  };

  const homeLabel = {
    fr: 'Accueil',
    ar: 'الرئيسية'
  };

  const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
  
  if (pathSegments?.length === 0 || 
      location?.pathname === '/agency-dashboard' || 
      location?.pathname === '/super-admin-dashboard') {
    return null;
  }

  const breadcrumbs = [
    {
      label: t('nav.home'),
      path: '/agency-dashboard'
    }
  ];

  let currentPath = '';
  pathSegments?.forEach((segment) => {
    currentPath += `/${segment}`;
    const label = routeLabels?.[currentPath];
    if (label) {
      breadcrumbs?.push({
        label,
        path: currentPath
      });
    }
  });

  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 text-sm">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs?.length - 1;
          
          return (
            <li key={crumb?.path} className="flex items-center gap-2">
              {index > 0 && (
                <Icon 
                  name="ChevronRight" 
                  size={16} 
                  className="text-muted-foreground"
                />
              )}
              {isLast ? (
                <span className="font-medium text-foreground">
                  {crumb?.label}
                </span>
              ) : (
                <Link
                  to={crumb?.path}
                  className="text-muted-foreground hover:text-primary transition-smooth"
                >
                  {crumb?.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default BreadcrumbNavigation;